module.exports = __webpack_public_path__ + "static/media/check-add-contract.8b9bc37d.svg";